<div class="chat-Box-container" cdkDragBoundary="#ContainerMain" cdkDrag>
  <div class="message_title">
    <h3>{{tenantName}}<br/>{{tenantPhone | phone:1}}</h3>
    <div>
      @if (minimize_icon) {
        <a href="javascript:;" class="close me-2" (click)="minimize()"><i class="fas fa-minus"></i></a>
      }
      <a href="javascript:;" class="close me-2" (click)="closeChat.emit()"><i class="fas fa-times-white"></i></a>
      @if (maximize_icon) {
        <a href="javascript:;" class="close me-2" (click)="maximize()"><i class="far fa-window-maximize"></i></a>
      }
    </div>
  </div>
  <div class="message_detail_out">
    <div class="scroll_sec" #scrollMe [scrollTop]="scrollMe.scrollHeight">
      @for (msg of filteredLogs; track msg) {
        <div>
          <div [ngClass]="{'receiver': msg.Type==368, 'sender': msg.Type==369}">
            <div class="date_time"><span>{{msg.FacilityDateTime | date: 'mediumDate'}}&nbsp;&nbsp;{{msg.FacilityDateTime | date: 'mediumTime'}}</span></div>
            <p class="pre-wrap-container">{{msg.Message}}</p>
          </div>
        </div>
      }
      <label class="no-sms">{{noMessages}}</label>
    </div>
    <div class="detail_bot_sec flex-container">
      <label for="">Template</label>
      <select class="form-select" [(ngModel)]="selectedLetterType" (ngModelChange)="onLetterTypeChange($event)">
        <option selected disabled value="null">--Select--</option>
        @for (Ltype of lettertypelist; track Ltype) {
          <option [value]="Ltype.Id">{{Ltype.Name}}
          </option>
        }
      </select>
    </div>
    <div class="detail_bot_sec">
      <span class="letter-count">{{smstext.length}}/1000</span>
      <textarea rows="5" class="form-control mb-3" [(ngModel)]="smstext" maxlength="1000" style="resize: none;"></textarea>
      <div class="d-flex justify-content-end">
        <div class="form-group button_tooltip">
          <button type="button" class="btn btn-primary" [disabled]="isSMSUnchecked || !isCellPhoneAvailable" (click)="sendTheSms()">Send</button>
          @if (isSMSUnchecked || !isCellPhoneAvailable) {
            <div class="button_tooltip_modal">
              <p class="mb-0">{{ !isCellPhoneAvailable? 'No Cell Phone number is available to send SMS.': isSMSUnchecked? 'Please select the SMS checkbox!': '' }}</p>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
</div>
@if (stopDraging) {
  <div class="stop-drag"></div>
}